import { render, staticRenderFns } from "./ReviewQuestionRemovalItem.vue?vue&type=template&id=0ac2835b"
import script from "./ReviewQuestionRemovalItem.vue?vue&type=script&lang=js"
export * from "./ReviewQuestionRemovalItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports